<template>
  <div>
    <div class="common-box margin-t10">
      <el-row class="row-one">
        <span class="row-one-title">资产详情 —</span>
        <span class="row-one-subTitle"> {{$route.query.name}}</span>
        <!-- <Reback class="row-one-fr" @click.native="$router.go(-1)"></Reback> -->
      </el-row>
      <el-radio-group class="radio-single-btn margin-t20" v-model="radio" size="medium">
        <el-radio-button :label="1">公募（{{total1}}）</el-radio-button>
        <el-radio-button :label="2">私募（{{total2}}）</el-radio-button>
      </el-radio-group>
      <!-- 公募 -->
      <div v-if="radio == 1">
        <el-table v-loading="loading1" element-loading-text="加载中..." :data="assetDetailsTableData" class="table-single margin-t20">
          <el-table-column label="序号" prop="rowNum" width="80"></el-table-column>
          <el-table-column label="基金代码" prop="fundCode" width="90">
            <template slot-scope="scope">
              <span>{{scope.row.fundCode}}</span>
              <i v-if="scope.row.isExists == 1" class="el-icon-alarm-clock rColor margin-l6"></i>
            </template>
          </el-table-column>
          <el-table-column label="基金名称" prop="fundName" width="180">
            <template slot-scope="scope">
              <a class="table-single-a" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundCode +'.html'" target="_blank">{{scope.row.fundName}}</a>
            </template>
          </el-table-column>
          <el-table-column label="最新净值" prop="unitEquity">
            <template slot-scope="scope"><span>{{parseFloat(scope.row.unitEquity).toFixed(4)}}</span></template>
          </el-table-column>
          <el-table-column label="净值日期" prop="dealDate"></el-table-column>
          <el-table-column label="持有份额(份)">
            <template slot-scope="scope"><span>{{parseFloat(scope.row.balFund).toFixed(2)}}</span></template>
          </el-table-column>
          <el-table-column label="最新市值(元)" prop="marketValue">
            <template slot-scope="scope"><span>{{parseFloat(scope.row.marketValue).toFixed(2)}}</span></template>
          </el-table-column>
          <el-table-column label="昨日收益(元)" prop="earnings">
            <template slot-scope="scope">
              <span v-if="scope.row.earnings > 0" class="rColor">{{'+'+scope.row.earnings}}</span>
              <span v-else-if="scope.row.earnings < 0" class="gColor">{{scope.row.earnings}}</span>
              <span v-else>{{scope.row.earnings}}</span>
            </template>
          </el-table-column>
          <el-table-column label="持有收益(元)" prop="holdEarnings">
            <template slot-scope="scope">
              <span v-if="scope.row.holdEarnings > 0" class="rColor">{{'+'+scope.row.holdEarnings}}</span>
              <span v-else-if="scope.row.holdEarnings < 0" class="gColor">{{scope.row.holdEarnings}}</span>
              <span v-else>{{scope.row.holdEarnings}}</span>
            </template>
          </el-table-column>
          <el-table-column label="持有收益率" prop="holdYield">
            <template slot-scope="scope">
              <span v-if="scope.row.holdYield > 0" class="rColor">{{'+'+ parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
              <span v-else-if="scope.row.holdYield < 0" class="gColor">{{ parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
              <span v-else>{{scope.row.holdYield =='--'?'--': parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <span class="table-single-btn-font" @click="notebook(scope.row)">{{scope.row.isExists == 0? '设置提醒':'修改提醒'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" @size-change="handleSizeChangeOne" :current-page.sync="public.page" :page-size="public.pageNum" layout="prev, pager, next" :total="total1" hide-on-single-page>
        </el-pagination>
      </div>
      <!-- 私募 -->
      <div v-else>
        <el-table v-loading="loading2" element-loading-text="加载中..." :data="privateAssetDetailsTableData" class="table-single margin-t20">
          <el-table-column label="序号" prop="rowNum" width="80"></el-table-column>
          <el-table-column label="基金代码" prop="fundCode" width="90">
            <template slot-scope="scope">
              <span>{{scope.row.fundCode}}</span>
              <i v-if="scope.row.isExists == 1" class="el-icon-alarm-clock rColor margin-l6"></i>
            </template>
          </el-table-column>
          <el-table-column label="基金名称" prop="fundName" width="180"></el-table-column>
          <el-table-column label="最新净值" prop="unitEquity"></el-table-column>
          <el-table-column label="更新日期" prop="dealDate"></el-table-column>
          <el-table-column label="基金份额(份)" prop="balFund">
            <template slot-scope="scope"><span>{{parseFloat(scope.row.balFund).toFixed(2)}}</span></template>
          </el-table-column>
          <el-table-column label="当前市值(元)" prop="marketValue">
            <template slot-scope="scope"><span>{{parseFloat(scope.row.marketValue).toFixed(2)}}</span></template>
          </el-table-column>
          <el-table-column label="持有收益(元)" prop="holdEarnings">
            <template slot-scope="scope">
              <span v-if="scope.row.holdEarnings > 0" class="rColor">{{'+'+scope.row.holdEarnings}}</span>
              <span v-else-if="scope.row.holdEarnings < 0" class="gColor">{{scope.row.holdEarnings}}</span>
              <span v-else>{{scope.row.holdEarnings}}</span>
            </template>
          </el-table-column>
          <el-table-column label="持有收益率" prop="holdYield">
            <template slot-scope="scope">
              <span v-if="scope.row.holdYield > 0" class="rColor">{{'+'+ parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
              <span v-else-if="scope.row.holdYield < 0" class="gColor">{{ parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
              <span v-else>{{scope.row.holdYield =='--'?'--': parseFloat(scope.row.holdYield*100).toFixed(2)+ "%"}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <span class="table-single-btn-font" @click="notebook(scope.row)">{{scope.row.isExists == 0? '设置提醒':'修改提醒'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChangeTwo" @size-change="handleSizeChangeTwo" :current-page.sync="private.page" :page-size="private.pageNum" layout="prev, pager, next" :total="total2" hide-on-single-page>
        </el-pagination>
      </div>

    </div>
    <!-- 记事本 新增 -->
    <el-dialog class="dialog-single-two" title="设置提醒" :visible.sync="dialogVisableAdd">
      <el-form :model="notepadFormAdd" ref="notepadFormAdd" :rules="notepadFormAddRules" label-width="110px" label-position="right" class="form-single">
        <el-form-item label="记事分类">
          <span>基金交易</span>
        </el-form-item>
        <el-form-item label="客户姓名">
          <span>{{$route.query.name}}</span>
        </el-form-item>
        <el-form-item label="基金名称">
          <span>{{notepadFormAdd.fundName}}</span>
        </el-form-item>
        <el-form-item label="提醒时间" prop="startDate">
          <el-date-picker v-model="notepadFormAdd.startDate" type="datetime" placeholder="选择提醒时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束提醒时间" prop="endDate">
          <el-date-picker v-model="notepadFormAdd.endDate" type="datetime" placeholder="选择结束提醒时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="记事内容" prop="con">
          <el-input v-model="notepadFormAdd.con" type="textarea" placeholder="请输入记事内容" :autosize="{minRows:3}"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="normal" @click="notepadFormAddFun()">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 记事本 修改 -->
    <el-dialog class="dialog-single-two" title="修改提醒" :visible.sync="dialogVisableEdit">
      <el-form :model="notepadFormEdit" ref="notepadFormEdit" :rules="notepadFormEditRules" label-width="110px" label-position="right" class="form-single">
        <el-form-item label="记事分类">
          <span>基金交易</span>
        </el-form-item>
        <el-form-item label="客户姓名">
          <span>{{$route.query.name}}</span>
        </el-form-item>
        <el-form-item label="基金名称" v-if="notepadFormEdit.fundName" prop="fundName">
          <span>{{notepadFormEdit.fundName}}</span>
        </el-form-item>
        <el-form-item label="提醒时间" prop="startDate">
          <el-date-picker v-model="notepadFormEdit.startDate" type="datetime" placeholder="选择提醒时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束提醒时间" prop="endDate">
          <el-date-picker v-model="notepadFormEdit.endDate" type="datetime" placeholder="选择结束提醒时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="记事内容" prop="con">
          <el-input v-model="notepadFormEdit.con" type="textarea" placeholder="请输入记事内容" :autosize="{minRows:3}"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="normal1" @click="notepadFormEditFun('sure')">确认</el-button>
          <el-button type="cancel" @click="notepadFormEditFun('cancel')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data () {
    return {
      radio: 1,
      assetDetailsTableData: [],
      privateAssetDetailsTableData: [],
      public: {
        page: 1,
        pageNum: 10,
      },
      private: {
        page: 1,
        pageNum: 10,
      },
      total1: 0,
      total2: 0,
      custno: '',
      loading1: true,
      loading2: true,
      // 记事本添加
      dialogVisableAdd: false,
      notepadFormAdd: {
        fundCode: '',
        fundName: '',
        con: '',
        startDate: '',
        endDate: ''
      },
      notepadFormAddRules: {
        con: [
          { required: 'true', message: '请输入记事内容', trigger: 'change' }
        ],
      },
      // 记事本修改
      dialogVisableEdit: false,
      notepadFormEdit: {
        id: '',
        fundName: '',
        con: '',
        startDate: '',
        endDate: ''
      },
      notepadFormEditRules: {
        con: [
          { required: 'true', message: '请输入记事内容', trigger: 'change' }
        ],
      },
      // 日期选择范围
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
    }
  },
  created () {
    this.custno = this.$route.query.key
  },
  mounted () {
    this.getPublicLists()
    this.getPrivateLists()
  },
  methods: {
    handleCurrentChangeOne (newPage) {
      this.public.page = newPage
      this.loading1 = true
      this.getPublicLists()
    },
    handleSizeChangeOne (newSize) {
      this.public.pageNum = newSize
      this.getPublicLists()
    },
    handleCurrentChangeTwo (newPage) {
      this.loading2 = true
      this.private.page = newPage
      this.getPrivateLists()
    },
    handleSizeChangeTwo (newSize) {
      this.private.pageNum = newSize
      this.getPrivateLists()
    },
    // 公募资产
    getPublicLists () {
      this.$http.post(this.$apiPath.getMutualFundPositionDetail, {
        AdviserCode: this.$commonJs.getCookie('code'),
        Custno: this.custno,
        page: this.public.page,
        pageNum: this.public.pageNum
      }).then(res => {
        // console.log(res);
        this.loading1 = false
        if (res.data.code == 200) {
          this.assetDetailsTableData = res.data.data.dataList
          this.total1 = res.data.data.recordCount
        }
      }).catch(err => { })
    },
    // 私募资产
    getPrivateLists () {
      this.$http.post(this.$apiPath.getPrivateFundPositionDetail, {
        AdviserCode: this.$commonJs.getCookie('code'),
        Custno: this.custno,
        page: this.private.page,
        pageNum: this.private.pageNum
      }).then(res => {
        // console.log(res);
        this.loading2 = false
        if (res.data.code == 200) {
          this.privateAssetDetailsTableData = res.data.data.dataList
          this.total2 = res.data.data.recordCount
        }
      }).catch(err => { })
    },
    // 记事本
    notebook (val) {
      if (val.isExists == 0) {//设置提醒
        this.notepadFormAdd = {
          fundCode: val.fundCode,
          fundName: val.fundName
        }
        this.dialogVisableAdd = true
      } else {//修改提醒
        this.notepadFormEdit = {
          id: val.id,
          fundName: val.fundName == '--' ? '' : val.fundName,
          con: val.content,
          startDate: val.startDate == '--' ? '' : val.startDate,
          endDate: val.endDate == '--' ? '' : val.endDate,
        }
        this.dialogVisableEdit = true
      }
    },
    // 添加记事本
    notepadFormAddFun () {
      this.$refs['notepadFormAdd'].validate((valid) => {
        if (valid) {
          let sdata = {
            AdviserCode: this.$commonJs.getCookie('code'),
            CustNo: this.custno ? this.custno : '',
            CustName: this.$route.query.name ? this.$route.query.name : '',
            FundCode: this.notepadFormAdd.fundCode ? this.notepadFormAdd.fundCode : '',
            FundName: this.notepadFormAdd.fundName ? this.notepadFormAdd.fundName : '',
            Type: '基金交易',
            Content: this.notepadFormAdd.con,
            StartDate: this.notepadFormAdd.startDate == null ? '' : this.notepadFormAdd.startDate,
            EndDate: this.notepadFormAdd.endDate == null ? '' : this.notepadFormAdd.endDate,
          }
          // console.log(sdata);
          this.$http.post(this.$apiPath.addAdvisorNoteBook, sdata).then(res => {
            if (res.data.code == 200) {
              this.$message.success('新增成功！');
              this.$refs['notepadFormAdd'].resetFields();
              this.dialogVisableAdd = false;
              if (this.radio == 1) {
                this.public.page = 1;
                this.loading1 = true
                this.getPublicLists();
              } else {
                this.private.page = 1;
                this.loading2 = true
                this.getPrivateLists();
              }
            }
          }).catch(err => { })
        }
      })
    },
    // 修改记事本
    notepadFormEditFun (opt) {
      if (opt == 'sure') {
        this.$refs['notepadFormEdit'].validate((valid) => {
          if (valid) {
            this.$http.post(this.$apiPath.updateAdvisorNoteBook, {
              AdviserCode: this.$commonJs.getCookie('code'),
              ID: this.notepadFormEdit.id,
              Content: this.notepadFormEdit.con,
              StartDate: this.notepadFormEdit.startDate == null ? '' : this.notepadFormEdit.startDate,
              EndDate: this.notepadFormEdit.endDate == null ? '' : this.notepadFormEdit.endDate
            }).then(res => {
              if (res.data.code == 200) {
                this.$message.success('修改成功！');
                this.dialogVisableEdit = false;
                if (this.radio == 1) {
                  this.loading1 = true
                  this.getPublicLists();
                } else {
                  this.loading2 = true
                  this.getPrivateLists();
                }
              }
            })
          }
        })
      } else {
        this.dialogVisableEdit = false;
      }
    },
  }
}
</script>


<style lang="less" scoped>
</style>